export default __webpack_public_path__ + "static/media/event.613a58fa.png";